module.exports = __webpack_public_path__ + "static/media/premierepro.e35506c5.svg";